import { IconButton, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TreeView } from '@mui/x-tree-view';
import { ConfigEntryType } from 'config/config';
import ArrowDownSLineIcon from 'remixicon-react/ArrowDownSLineIcon';
import ArrowRightSLineIcon from 'remixicon-react/ArrowRightSLineIcon';
import useRetrospectivesStore from 'store/useRetrospectivesStore';
import { SyntheticEvent } from 'react';
import useUserData from 'hooks/useUserData';
import { useParams } from 'react-router-dom';
import RetroPhase from './RetroPhase';

type RenderRetrospectiveProps = {
  phase: ConfigEntryType;
  phaseIndex: number;
  showCategoryTree?: boolean;
};

function RenderRetrospective({
  phase,
  phaseIndex,
  showCategoryTree = true,
}: RenderRetrospectiveProps) {
  const { projectId = '' } = useParams();
  const { companyId } = useUserData();
  const { projectRetrospectivesState, setExpandedCategories } = useRetrospectivesStore();

  const expandedCategories = [phase.id as string, ...phase.entryValues];

  const handleNodesToggle = (_: SyntheticEvent, ids: string[], phase: ConfigEntryType) => {
    setExpandedCategories({
      type: 'projectRetrospectivesState',
      companyId,
      projectId,
      phase: phase.entryCode,
      expandedCategories:
        (
          projectRetrospectivesState?.[companyId]?.[projectId]?.[phase.entryCode]
            ?.expandedCategories || []
        ).length === 0 &&
        ids.length === 1 &&
        ids.includes(phase.id || phase.entryCode)
          ? [phase.id || phase.entryCode, ...phase.entryValues]
          : ids,
    });
  };

  return (
    <TreeView
      aria-label="insights-tree-view"
      defaultCollapseIcon={
        <IconButton size="small">
          <ArrowDownSLineIcon />
        </IconButton>
      }
      defaultExpandIcon={
        <IconButton size="small">
          <ArrowRightSLineIcon />
        </IconButton>
      }
      expanded={
        projectRetrospectivesState?.[companyId]?.[projectId]?.[phase.entryCode]
          ?.expandedCategories ||
        expandedCategories ||
        []
      }
      onNodeToggle={(...params) => handleNodesToggle(...params, phase)}
    >
      <RetroPhase phase={phase} showCategoryTree={showCategoryTree} />
    </TreeView>
  );
}

export default RenderRetrospective;
